export type DifficultyLevel = 'beginner' | 'experienced' | 'expert';

export interface DifficultySettings {
  name: string;
  lives: number;
  barrierCount: number;
  enemyBaseSpeed: number;
  enemyFireRate: number; // ms between shots (lower = faster)
  enemyProjectileSpeed: number;
  speedIncreasePerWave: number; // percentage
  powerUpDropRate: number; // percentage chance
  scoreMultiplier: number;
  color: number; // For UI display
}

export const DIFFICULTY_PRESETS: Record<DifficultyLevel, DifficultySettings> = {
  beginner: {
    name: 'BEGINNER',
    lives: 10,
    barrierCount: 4,
    enemyBaseSpeed: 50,
    enemyFireRate: 2000,
    enemyProjectileSpeed: 200,
    speedIncreasePerWave: 0.10,
    powerUpDropRate: 0.15,
    scoreMultiplier: 1.0,
    color: 0x00ff00, // Green
  },
  experienced: {
    name: 'EXPERIENCED',
    lives: 10,
    barrierCount: 3,
    enemyBaseSpeed: 75,
    enemyFireRate: 1500,
    enemyProjectileSpeed: 275,
    speedIncreasePerWave: 0.15,
    powerUpDropRate: 0.10,
    scoreMultiplier: 1.5,
    color: 0xffff00, // Yellow
  },
  expert: {
    name: 'EXPERT',
    lives: 10,
    barrierCount: 2,
    enemyBaseSpeed: 100,
    enemyFireRate: 1000,
    enemyProjectileSpeed: 350,
    speedIncreasePerWave: 0.20,
    powerUpDropRate: 0.05,
    scoreMultiplier: 2.0,
    color: 0xff0000, // Red
  },
};

// Current game difficulty (can be changed from settings)
let currentDifficulty: DifficultyLevel = 'experienced';

export function getDifficulty(): DifficultyLevel {
  return currentDifficulty;
}

export function setDifficulty(level: DifficultyLevel): void {
  currentDifficulty = level;
}

export function getDifficultySettings(): DifficultySettings {
  return DIFFICULTY_PRESETS[currentDifficulty];
}





